import { UserManagerSettings } from 'oidc-client';

interface ClientSettings {
    userManagerSettings: UserManagerSettings;
}

const l = typeof window !== 'undefined' ? window.location : undefined;
const appUrlLeftPart = l ? `${l.protocol}//${l.hostname}${l.port ? `:${l.port}` : ''}` : undefined;
let envName = 'dev';
if (l) {
    if (
        l.hostname.endsWith('livedoc.transmissionmedia.ca') ||
        l.hostname.endsWith('livedoc-dr.transmissionmedia.ca')
    ) {
        envName = 'prod';
    }
}

const baseSettings: ClientSettings = {
    userManagerSettings: {
        authority: 'https://livedoc-dev.transmissionmedia.ca',
        client_id: 'sitebuilderui',
        response_type: 'token id_token',
        scope: 'openid profile livedocApi',
        redirect_uri: appUrlLeftPart ? `${appUrlLeftPart}/_oidc/signin` : '',
        silent_redirect_uri: appUrlLeftPart ? `${appUrlLeftPart}/_oidc/silent-renew` : '',
        automaticSilentRenew: true,
        filterProtocolClaims: true,
        loadUserInfo: true,
        clockSkew: 60 * 15, // seconds
    },
};

const envSettings: Record<string, ClientSettings> = {
    dev: {
        ...baseSettings,
    },
    prod: {
        ...baseSettings,
        userManagerSettings: {
            ...baseSettings.userManagerSettings,
            authority: 'https://livedoc.transmissionmedia.ca',
        },
    },
};

const settings = envSettings[envName];
export default settings;
